/**
 * Helpers de planes (v2 tiers: free, starter, professional, business, enterprise).
 */

/**
 * Planes sales-touch cuyo precio NO se muestra: el setup es custom
 * (multi-restaurante, whitelabel, SLA, Account Manager) y se cierra con ventas,
 * no por self-service checkout.
 *
 * Se resuelve por `planId` porque el backend NO envía un flag de precio custom
 * para enterprise (solo `monthly: 199000`), así que confiar solo en
 * `pricing.custom` dejaba el precio visible y permitía un checkout de MP para
 * enterprise. NER-3236 (decisión Diego): mostrar "Consultanos" en vez del número.
 */
export const CUSTOM_PRICING_PLAN_IDS = ['enterprise'];

/**
 * ¿El plan oculta su precio (muestra "Consultanos") y es sales-touch?
 * Cubre los planes de CUSTOM_PRICING_PLAN_IDS además de cualquier precio
 * marcado con `custom: true` (flag explícito, por si el backend lo agrega).
 *
 * @param {object} plan  Plan con `planId` y `pricing`.
 * @param {string} [currency]  Moneda seleccionada (ARS/USD/BRL). Default: ARS.
 * @returns {boolean}
 */
export function hasCustomPricing(plan, currency) {
  if (!plan) return false;
  if (CUSTOM_PRICING_PLAN_IDS.includes(plan.planId)) return true;
  const pricing = (currency && plan.pricing?.[currency]) || plan.pricing?.ARS || {};
  return !!(pricing.custom || plan.pricing?.custom);
}
